import { render, staticRenderFns } from "./TinyMceEditor.vue?vue&type=template&id=32167854"
import script from "./TinyMceEditor.vue?vue&type=script&lang=js"
export * from "./TinyMceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports